import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    backgroundColor: 'rgba(194,224,255,0.5)',
    border: '1px solid rgba(194,224,255,0.2)',
    borderRadius: '4px',
    height: 'unset',
  },
});

const abbreviation = (string) => {
  const words = string.split(' ');
  let abb = '';
  for (let i = 0; i < words.length; i++) {
    abb += words[i][0];
  }
  return abb;
};

const ModelTypeChip = (props) => {
  const { classes, type } = props;
  if (!type) return null;
  return <Chip label={abbreviation(type)} className={classes.root} />;
};

ModelTypeChip.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
};

ModelTypeChip.defaultProps = {
  type: null,
};

export default withStyles(styles)(ModelTypeChip);
